import { MultiStepForm, UserProfileModel } from '@nw/fields-manager';
import { GetProductDetailsResponseType } from '@nw/shared/data-access';

import { BaseProductDetail } from './BaseProductDetail';
import { FlexibleTenureEMIPricingDetails } from './FlexibleTenureEMIPricingDetails';

interface EMIConfig {
  no_of_months: number;
  interest_rate: number;
}

export class FlexibleTenureEMIProductDetail extends BaseProductDetail {
  readonly installmentType = 'EMI';
  readonly emiSelectionType = 'POST_ORDER';
  readonly availableEMIConfigs: EMIConfig[];
  readonly initialPricingDetails: FlexibleTenureEMIPricingDetails;
  currentPricingDetails: FlexibleTenureEMIPricingDetails;

  constructor(
    productDetails: GetProductDetailsResponseType,
    userProfileDetails: UserProfileModel | null = null
  ) {
    super(productDetails);

    this.availableEMIConfigs =
      this.installmentPricingDetails?.available_emi_installment_configs || [];

    this.initialPricingDetails = new FlexibleTenureEMIPricingDetails(
      productDetails
    );
    this.currentPricingDetails = this.initialPricingDetails;
    this.form = this.parsedUserExtraInfoConfig
      ? new MultiStepForm(
          this.parsedUserExtraInfoConfig.registration_form_details,
          userProfileDetails,
          this
        )
      : undefined;
  }

  shouldShowCouponApplyButton(): boolean {
    return (
      this.currentPricingDetails.amountToBePaid > 0 &&
      (this.parsedExtraData?.should_show_coupon_apply_button ?? true)
    );
  }

  updateCurrentDetailsWithReferralCodeResponse(
    pricingDetailsObject: FlexibleTenureEMIPricingDetails
  ) {
    this.currentPricingDetails = pricingDetailsObject;
  }

  updateCurrentDetailsWithInitialPricingDetails() {
    this.currentPricingDetails = this.initialPricingDetails;
  }

  isFlexibleTenureAvailable(): boolean {
    return this.availableEMIConfigs.length > 1;
  }

  getEMIConfigByMonths(months: number): EMIConfig | undefined {
    return this.availableEMIConfigs.find(
      (config) => config.no_of_months === months
    );
  }
}
